"use strict";
// noinspection JSUnusedGlobalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpInterface = exports.ContentType = void 0;
const axios_1 = __importDefault(require("axios"));
var ContentType;
(function (ContentType) {
    ContentType["IMAGE"] = "image";
    ContentType["VIDEO"] = "video";
    ContentType["UNKNOWN"] = "unknown";
})(ContentType || (exports.ContentType = ContentType = {}));
class HttpInterface {
    constructor(config) {
        this.http = axios_1.default.create(config);
    }
    Login(req) {
        return this.http.post("/api/auth/login", req);
    }
    Register(req) {
        return this.http.post("/api/auth/register", req);
    }
    Invitation(token) {
        return this.http.get(`/api/auth/invitation?token=${token}`);
    }
    Profile() {
        return this.http.get("/api/auth/profile");
    }
    UpdateProfile(dto) {
        return this.http.patch("/api/auth/profile", dto);
    }
    UpdateProfilePassword(dto) {
        return this.http.patch("/api/auth/change-password", dto);
    }
    RequestPasswordReset(dto) {
        return this.http.post("/api/auth/request-reset", dto);
    }
    ConsumePasswordReset(dto) {
        return this.http.post("/api/auth/consume-reset", dto);
    }
    AcceptCompanyInvite(token) {
        return this.http.post(`/api/company/${token}/accept-invite`);
    }
    Verify(dto) {
        return this.http.post("/api/auth/verify", dto);
    }
    ResendVerification(email) {
        return this.http.post("/api/auth/resend-verify", { email });
    }
    Logout() {
        return this.http.post("/api/auth/logout");
    }
    CreateCompany(dto) {
        return this.http.post("/api/company", dto);
    }
    DeleteCompany(id) {
        return this.http.delete(`/api/company/${id}`);
    }
    RenameCompany(id, dto) {
        return this.http.patch(`/api/company/${id}/name`, dto);
    }
    UpdateCompanyInfo(dto) {
        return this.http.patch("/api/company/company", dto);
    }
    UpdateSocialStatsReport() {
        return this.http.post("/api/reports");
    }
    GetReportPostsSuccess(from, to, zone) {
        return this.http.get(`/api/reports/post-success?from=${from}&to=${to}&zone=${zone}`);
    }
    GetTopEngagedPosts(from, to, limit = 10) {
        const params = new URLSearchParams();
        if (from)
            params.append("from", from);
        if (to)
            params.append("to", to);
        params.append("limit", String(limit));
        return this.http.get(`/api/reports/top-posts?${params.toString()}`);
    }
    CompanyInviteUser(companyID, email, role) {
        return this.http.post(`/api/company/${companyID}/invite`, {
            email,
            role,
        });
    }
    CompanyRevokeUserInvite(companyID, inviteID) {
        return this.http.delete(`/api/company/${companyID}/invite/${inviteID}`);
    }
    CompanyDeleteUser(companyID, userID) {
        return this.http.delete(`/api/company/${companyID}/users/${userID}`);
    }
    MarketingPlan() {
        return this.http.get("/api/plan");
    }
    SaveMarketingPlan(plan) {
        return this.http.put("/api/plan", { plan });
    }
    GenerateMarketingPlan() {
        return this.lrp({
            method: "POST",
            url: "/api/plan",
        });
    }
    GetCompanies() {
        return this.http.get("/api/company");
    }
    GetPostsList() {
        return this.http.get("/api/calendar/list");
    }
    GetPostsListRange(zone, from, to) {
        return this.http.get("/api/calendar/list/range", {
            params: { zone, from, to },
        });
    }
    GetPostsBatch(dto) {
        return this.http.post("/api/calendar/batch", dto);
    }
    GetPostsLatest(limit = 10) {
        return this.http.get(`/api/calendar/latest?limit=${limit}`);
    }
    GetPostsRecent(limit = 10) {
        return this.http.get(`/api/calendar/recent?limit=${limit}`);
    }
    GetPublishingQueue(platform) {
        return this.http.get("/api/calendar/publishing-queue", {
            params: { platform },
        });
    }
    GetPostWithSiblings(id) {
        return this.http.get(`/api/calendar/${id}/with-siblings`);
    }
    GetNextPost(id) {
        return this.http.get(`/api/calendar/${id}/next`);
    }
    CreatePost(dto) {
        return this.http.post("/api/calendar", dto);
    }
    UpdatePost(id, dto) {
        return this.http.patch(`/api/calendar/${id}`, dto);
    }
    DeletePost(id) {
        return this.http.delete(`/api/calendar/${id}`);
    }
    RewritePost(id, instructions) {
        return this.http.post(`/api/calendar/${id}/rewrite`, {
            instructions,
        });
    }
    RefineContent(content, instructions, platform, hasMedia) {
        return this.http.post("/api/calendar/refine", {
            content,
            instructions,
            platform,
            hasMedia,
        });
    }
    GenerateBlogSeo(dto) {
        return this.http.post("/api/calendar/generate-seo", dto);
    }
    SubmitPostForApproval(id) {
        return this.http.post(`/api/calendar/${id}/submit-for-approval`);
    }
    ApprovePost(id) {
        return this.http.post(`/api/calendar/${id}/approve`);
    }
    RejectPost(id, reason) {
        return this.http.post(`/api/calendar/${id}/reject`, { reason });
    }
    BulkApprovePosts(ids) {
        return this.http.post("/api/calendar/approve/bulk", {
            IDs: ids,
        });
    }
    GetPendingApprovalPosts() {
        return this.http.get("/api/calendar/pending-approval");
    }
    DeleteScheduledPosts(dto) {
        return this.http.delete("/api/calendar/delete/scheduled", { data: dto });
    }
    GeneratePosts(dto) {
        return this.lrp({
            method: "post",
            url: "/api/calendar/generate",
            data: dto,
        });
    }
    GenerateBlogPosts(dto) {
        return this.lrp({
            method: "post",
            url: "/api/calendar/generate/blog",
            data: dto,
        });
    }
    GenerateImages(dto) {
        return this.http.post("/api/content/generate", dto);
    }
    GenerateImagesV2(dto) {
        return this.http.post("/api/content/generate/v2", dto);
    }
    SaveGeneratedV2(imageUrl) {
        return this.http.post("/api/content/generate/v2/save", {
            imageUrl,
        });
    }
    GenerateImageFromPost(dto) {
        return this.http.post("/api/content/generate/v2/from-post", dto);
    }
    GenerateCarousel(dto) {
        return this.http.post("/api/content/carousel/generate", dto);
    }
    RegenerateCarouselSlide(dto) {
        return this.http.post("/api/content/carousel/regenerate-slide", dto);
    }
    ExportCarousel(dto) {
        return this.http.post("/api/content/carousel/export", dto);
    }
    GenerateCarouselCaption(dto) {
        return this.http.post("/api/content/carousel/caption", dto);
    }
    SaveImageFromUrl(dto) {
        return this.http.post("/api/content/import", dto);
    }
    GetFacebookStatus() {
        return this.http.get("/api/integrations/facebook/status");
    }
    GetFacebookProfiles() {
        return this.http.get("/api/integrations/facebook/profiles");
    }
    SetFacebookProfile(dto) {
        return this.http.post("/api/integrations/facebook/profile", dto);
    }
    FacebookConnect(inviteToken) {
        return this.http.get(`/api/integrations/facebook/connect${inviteToken ? `?inviteToken=${inviteToken}` : ""}`);
    }
    FacebookDisconnect() {
        return this.http.post("/api/integrations/facebook/disconnect");
    }
    InstagramConnect() {
        return this.http.get("/api/integrations/instagram/connect");
    }
    GetInstagramStatus() {
        return this.http.get("/api/integrations/instagram/status");
    }
    GetInstagramProfiles() {
        return this.http.get("/api/integrations/instagram/profiles");
    }
    SetInstagramProfile(dto) {
        return this.http.post("/api/integrations/instagram/profile", dto);
    }
    InstagramDisconnect() {
        return this.http.post("/api/integrations/instagram/disconnect");
    }
    GetThreadsStatus() {
        return this.http.get("/api/integrations/threads/status");
    }
    ThreadsConnect() {
        return this.http.get("/api/integrations/threads/connect");
    }
    ThreadsDisconnect() {
        return this.http.post("/api/integrations/threads/disconnect");
    }
    TikTokConnect() {
        return this.http.get("/api/integrations/tiktok/connect");
    }
    TikTokStatus() {
        return this.http.get("/api/integrations/tiktok/status");
    }
    TikTokDisconnect() {
        return this.http.post("/api/integrations/tiktok/disconnect");
    }
    XStatus() {
        return this.http.get("/api/integrations/x/status");
    }
    XConnect() {
        return this.http.get("/api/integrations/x/connect");
    }
    XDisconnect() {
        return this.http.post("/api/integrations/x/disconnect");
    }
    GetXAdminCheck() {
        return this.http.get("/api/integrations/x/admin/check");
    }
    GetXAdminSpend(year, month) {
        const params = new URLSearchParams();
        if (year != null)
            params.set("year", String(year));
        if (month != null)
            params.set("month", String(month));
        const qs = params.toString();
        return this.http.get(`/api/integrations/x/admin/spend${qs ? `?${qs}` : ""}`);
    }
    SetXPublishingEnabled(enabled) {
        return this.http.post("/api/integrations/x/admin/publishing", { enabled });
    }
    CanvaConnect() {
        return this.http.get("/api/integrations/canva/connect");
    }
    CanvaStatus() {
        return this.http.get("/api/integrations/canva/status");
    }
    CanvaDisconnect() {
        return this.http.post("/api/integrations/canva/disconnect");
    }
    CanvaListDesigns(params) {
        const searchParams = new URLSearchParams();
        if (params === null || params === void 0 ? void 0 : params.continuation) {
            searchParams.append("continuation", params.continuation);
        }
        if ((params === null || params === void 0 ? void 0 : params.limit) !== undefined) {
            searchParams.append("limit", String(params.limit));
        }
        if (params === null || params === void 0 ? void 0 : params.assetType) {
            searchParams.append("assetType", params.assetType);
        }
        if (params === null || params === void 0 ? void 0 : params.query) {
            searchParams.append("query", params.query);
        }
        if (params === null || params === void 0 ? void 0 : params.sortBy) {
            searchParams.append("sortBy", params.sortBy);
        }
        if (params === null || params === void 0 ? void 0 : params.dateFilter) {
            searchParams.append("dateFilter", params.dateFilter);
        }
        if (params === null || params === void 0 ? void 0 : params.canvaFolderId) {
            searchParams.append("canvaFolderId", params.canvaFolderId);
        }
        const qs = searchParams.toString();
        return this.http.get(`/api/integrations/canva/designs${qs ? `?${qs}` : ""}`);
    }
    CanvaGetEditUrl(designId, contentFileId) {
        const qs = contentFileId
            ? `?contentFileId=${encodeURIComponent(String(contentFileId))}`
            : "";
        return this.http.get(`/api/integrations/canva/designs/${encodeURIComponent(designId)}/edit-url${qs}`);
    }
    CanvaCreateDesign(dto) {
        return this.http.post("/api/integrations/canva/designs/create", dto);
    }
    CanvaGetSyncSettings() {
        return this.http.get("/api/integrations/canva/sync-settings");
    }
    CanvaUpdateSyncSettings(dto) {
        return this.http.post("/api/integrations/canva/sync-settings", dto);
    }
    CanvaReimportContentFile(contentFileId) {
        return this.http.post(`/api/integrations/canva/reimport/${contentFileId}`);
    }
    CanvaStartImport(dto) {
        return this.http.post("/api/integrations/canva/import", dto);
    }
    CanvaImportStatus(importId) {
        return this.http.get(`/api/integrations/canva/import/${importId}`);
    }
    CanvaAuditEvents(limit, offset) {
        const params = new URLSearchParams();
        if (limit !== undefined) {
            params.set("limit", String(limit));
        }
        if (offset !== undefined) {
            params.set("offset", String(offset));
        }
        const qs = params.toString();
        return this.http.get(`/api/integrations/canva/audit-events${qs ? `?${qs}` : ""}`);
    }
    CanvaRetryImportItem(itemId, folderId) {
        return this.http.post(`/api/integrations/canva/import/items/${itemId}/retry`, { folderId });
    }
    HeyGenStatus() {
        return this.http.get("/api/integrations/heygen/status");
    }
    HeyGenConnect(dto) {
        return this.http.post("/api/integrations/heygen/connect", dto);
    }
    HeyGenDisconnect() {
        return this.http.post("/api/integrations/heygen/disconnect");
    }
    HeyGenListVideos(params) {
        const searchParams = new URLSearchParams();
        if (params === null || params === void 0 ? void 0 : params.token) {
            searchParams.append("token", params.token);
        }
        if ((params === null || params === void 0 ? void 0 : params.limit) !== undefined) {
            searchParams.append("limit", String(params.limit));
        }
        if (params === null || params === void 0 ? void 0 : params.title) {
            searchParams.append("title", params.title);
        }
        if (params === null || params === void 0 ? void 0 : params.folderId) {
            searchParams.append("folderId", params.folderId);
        }
        const qs = searchParams.toString();
        return this.http.get(`/api/integrations/heygen/videos${qs ? `?${qs}` : ""}`);
    }
    HeyGenVideoDetails(videoId) {
        return this.http.get(`/api/integrations/heygen/videos/${encodeURIComponent(videoId)}`);
    }
    HeyGenListFolders(folderIds) {
        const qs = new URLSearchParams({ ids: folderIds.join(",") }).toString();
        return this.http.get(`/api/integrations/heygen/folders?${qs}`);
    }
    HeyGenStartImport(dto) {
        return this.http.post("/api/integrations/heygen/import", dto);
    }
    HeyGenImportStatus(importId) {
        return this.http.get(`/api/integrations/heygen/import/${importId}`);
    }
    HeyGenRetryImportItem(itemId) {
        return this.http.post(`/api/integrations/heygen/import/items/${itemId}/retry`);
    }
    VideoGenerationAvailability() {
        return this.http.get("/api/video-generations/availability");
    }
    VideoGenerationPreview(dto) {
        return this.http.post("/api/video-generations/preview", dto);
    }
    VideoGenerationStart(generationId, dto) {
        return this.http.post(`/api/video-generations/${generationId}/generate`, dto);
    }
    VideoGenerationList(params) {
        const searchParams = new URLSearchParams();
        if ((params === null || params === void 0 ? void 0 : params.postId) !== undefined) {
            searchParams.append("postId", String(params.postId));
        }
        if ((params === null || params === void 0 ? void 0 : params.limit) !== undefined) {
            searchParams.append("limit", String(params.limit));
        }
        const qs = searchParams.toString();
        return this.http.get(`/api/video-generations${qs ? `?${qs}` : ""}`);
    }
    VideoGenerationGet(generationId) {
        return this.http.get(`/api/video-generations/${generationId}`);
    }
    VideoGenerationRetry(generationId, dto) {
        return this.http.post(`/api/video-generations/${generationId}/retry`, dto !== null && dto !== void 0 ? dto : {});
    }
    VideoGenerationRegenerate(generationId, dto) {
        return this.http.post(`/api/video-generations/${generationId}/regenerate`, dto);
    }
    VideoGenerationCancel(generationId) {
        return this.http.post(`/api/video-generations/${generationId}/cancel`);
    }
    VideoGenerationOptions() {
        return this.http.get("/api/video-generations/options");
    }
    VideoGenerationSaveDefaults(dto) {
        return this.http.put("/api/video-generations/defaults", dto);
    }
    VideoGenerationUsage() {
        return this.http.get("/api/video-generations/usage");
    }
    VideoGenerationSaveBudget(dto) {
        return this.http.put("/api/video-generations/budget", dto);
    }
    VideoGenerationActive() {
        return this.http.get("/api/video-generations/active");
    }
    VideoGenerationAdminCheck() {
        return this.http.get("/api/video-generations/admin/check");
    }
    VideoGenerationAdminOverview() {
        return this.http.get("/api/video-generations/admin/overview");
    }
    LinkedinConnect() {
        return this.http.get("/api/integrations/linkedin/connect");
    }
    LinkedinDisconnect() {
        return this.http.post("/api/integrations/linkedin/disconnect");
    }
    LinkedinStatus() {
        return this.http.get("/api/integrations/linkedin/status");
    }
    WordpressConnect(dto) {
        return this.http.post("/api/integrations/wordpress/connect", dto);
    }
    WordpressDisconnect() {
        return this.http.post("/api/integrations/wordpress/disconnect");
    }
    WordpressStatus() {
        return this.http.get("/api/integrations/wordpress/status");
    }
    /** App Market / external install URL for end customers. */
    WixConnect() {
        return this.http.get("/api/integrations/wix/connect");
    }
    WixStatus() {
        return this.http.get("/api/integrations/wix/status");
    }
    WixDisconnect() {
        return this.http.post("/api/integrations/wix/disconnect");
    }
    GoogleProfileConnect(inviteToken) {
        return this.http.get(`/api/integrations/google/profile/connect${inviteToken ? `?inviteToken=${inviteToken}` : ""}`);
    }
    GoogleSearchConsoleConnect() {
        return this.http.get("/api/integrations/google/search-console/connect");
    }
    GoogleSearchConsoleDisconnect() {
        return this.http.post("/api/integrations/google/search-console/disconnect");
    }
    GoogleSearchConsoleStatus() {
        return this.http.get("/api/integrations/google/search-console/status");
    }
    GoogleSearchConsoleGetWebsites() {
        return this.http.post("/api/integrations/google/search-console/websites");
    }
    GoogleSearchConsoleGetWebsite() {
        return this.http.get("/api/integrations/google/search-console/website");
    }
    GoogleSearchConsoleSetWebsite(dto) {
        return this.http.post("/api/integrations/google/search-console/website", dto);
    }
    GoogleMyBusinessConnect() {
        return this.http.get("/api/integrations/google/my-business/connect");
    }
    GoogleMyBusinessDisconnect() {
        return this.http.post("/api/integrations/google/my-business/disconnect");
    }
    GoogleMyBusinessStatus() {
        return this.http.get("/api/integrations/google/my-business/status");
    }
    /** Master business profile (Profile & Review Manager foundation). */
    LocationsGetMaster(googleLocationId) {
        return this.http.get("/api/locations/master", {
            params: googleLocationId ? { googleLocationId } : undefined,
        });
    }
    LocationsEnsureMaster(googleLocationId) {
        return this.http.post("/api/locations/master/ensure", {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    LocationsImportFromGoogle(googleLocationId) {
        return this.http.post("/api/locations/master/import-from-google", {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    /** Persist the master profile. Does not push to connected platforms. */
    LocationsUpdateMaster(dto) {
        return this.http.patch("/api/locations/master", dto);
    }
    /** Push the current master profile to every connected platform. */
    LocationsPublishEverywhere(googleLocationId) {
        return this.http.post("/api/locations/master/publish", {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    /** Push master LocalBusiness JSON-LD to WordPress (Firestarter SEO plugin). */
    LocationsSyncWebsiteSchema(googleLocationId) {
        return this.http.post("/api/locations/master/sync-website-schema", {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    /** Edit history for the master profile (who / what / when / platforms). */
    LocationsListHistory(limit = 50, googleLocationId) {
        return this.http.get("/api/locations/master/history", {
            params: Object.assign({ limit }, (googleLocationId ? { googleLocationId } : {})),
        });
    }
    LocationsCheckDrift(googleLocationId) {
        return this.http.post("/api/locations/master/check-drift", {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    /** Google → platform category mapping status + options for manual picks. */
    LocationsGetCategoryMappings(googleLocationId) {
        return this.http.get("/api/locations/master/category-mappings", { params: googleLocationId ? { googleLocationId } : undefined });
    }
    LocationsUpdateCategoryMappings(dto, googleLocationId) {
        return this.http.patch("/api/locations/master/category-mappings", dto, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    LocationsGetListingHealth(googleLocationId) {
        return this.http.get("/api/locations/master/listing-health", { params: googleLocationId ? { googleLocationId } : undefined });
    }
    LocationsListListingHealth() {
        return this.http.get("/api/locations/master/listing-health/all");
    }
    LocationsGetReviewReplyRules() {
        return this.http.get("/api/locations/master/review-reply-rules");
    }
    LocationsUpdateReviewReplyRules(dto) {
        return this.http.patch("/api/locations/master/review-reply-rules", dto);
    }
    LocationsListReviews(refresh = false, googleLocationId) {
        return this.http.get("/api/locations/master/reviews", {
            params: Object.assign(Object.assign({}, (refresh ? { refresh: "1" } : {})), (googleLocationId ? { googleLocationId } : {})),
        });
    }
    LocationsRefreshReviews(googleLocationId) {
        return this.http.post("/api/locations/master/reviews/refresh", {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    /** Dev/manual: send weekly review summary email for the current company. */
    LocationsSendWeeklyReviewSummary(googleLocationId) {
        return this.http.post("/api/locations/master/reviews/weekly-summary", {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    LocationsReplyToReview(reviewId, dto, googleLocationId) {
        return this.http.post(`/api/locations/master/reviews/${reviewId}/reply`, dto, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    LocationsGenerateReviewReply(reviewId, googleLocationId) {
        return this.http.post(`/api/locations/master/reviews/${reviewId}/generate-reply`, {}, { params: googleLocationId ? { googleLocationId } : undefined });
    }
    GoogleMyBusinessGetAccounts() {
        return this.http.get("/api/integrations/google/my-business/accounts");
    }
    GoogleMyBusinessGetAccount() {
        return this.http.get("/api/integrations/google/my-business/account");
    }
    GoogleMyBusinessSetAccount(dto) {
        return this.http.post("/api/integrations/google/my-business/account", dto);
    }
    GoogleMyBusinessResyncAccount() {
        return this.http.post("/api/integrations/google/my-business/resync-account");
    }
    GoogleMyBusinessGetSelectedLocation() {
        return this.http.get("/api/integrations/google/my-business/location");
    }
    GoogleMyBusinessSetSelectedLocation(dto) {
        return this.http.post("/api/integrations/google/my-business/location", dto);
    }
    GoogleMyBusinessGetLocations() {
        return this.http.get("/api/integrations/google/my-business/locations");
    }
    GoogleMyBusinessGetLocation(locationId) {
        return this.http.get(`/api/integrations/google/my-business/locations/${locationId}`);
    }
    GoogleMyBusinessRefreshLocation(locationId) {
        return this.http.post(`/api/integrations/google/my-business/locations/${locationId}/refresh`, {});
    }
    GoogleMyBusinessGetLocationAvailableAttributes(locationId) {
        return this.http.get(`/api/integrations/google/my-business/locations/${locationId}/available-attributes`);
    }
    GoogleMyBusinessGetLocationAttributes(locationId) {
        return this.http.get(`/api/integrations/google/my-business/locations/${locationId}/attributes`);
    }
    GoogleMyBusinessGetLocationReviews(locationID) {
        return this.http.get(`/api/integrations/google/my-business/locations/${locationID}/reviews`);
    }
    GoogleMyBusinessRefreshLocationReviews(locationID) {
        return this.http.post(`/api/integrations/google/my-business/locations/${locationID}/reviews/refresh`, {});
    }
    GoogleMyBusinessUpdateLocationReviewReply(locationID, reviewID, dto) {
        return this.http.post(`/api/integrations/google/my-business/locations/${locationID}/reviews/${reviewID}/reply`, dto);
    }
    GoogleMyBusinessDeleteLocationReviewReply(locationID, reviewID) {
        return this.http.delete(`/api/integrations/google/my-business/locations/${locationID}/reviews/${reviewID}/reply`);
    }
    GoogleMyBusinessGenerateLocationReviewReply(locationID, reviewID) {
        return this.lrp({
            method: "POST",
            url: `/api/integrations/google/my-business/locations/${locationID}/reviews/${reviewID}/reply/generate`,
        });
    }
    GoogleMyBusinessGetLocationMedia(locationId) {
        return this.http.get(`/api/integrations/google/my-business/locations/${locationId}/media`);
    }
    GoogleMyBusinessGetCategories(languageCode, regionCode, view) {
        return this.http.get("/api/integrations/google/my-business/categories", { params: { languageCode, regionCode, view } });
    }
    GoogleMyBusinessUpdateBusinessInfo(location, dto) {
        return this.http.patch(`/api/integrations/google/my-business/locations/${location}`, dto);
    }
    GoogleMyBusinessUploadLocationMedia(locationID, ids) {
        return this.http.post(`/api/integrations/google/my-business/locations/${locationID}/media`, { ids });
    }
    GoogleMyBusinessDeleteLocationMedia(locationID, mediaID) {
        return this.http.delete(`/api/integrations/google/my-business/locations/${locationID}/media/${mediaID}`);
    }
    GoogleAnalyticsConnect() {
        return this.http.get("/api/integrations/google/analytics/connect");
    }
    GoogleAnalyticsDisconnect() {
        return this.http.post("/api/integrations/google/analytics/disconnect");
    }
    GoogleAnalyticsStatus() {
        return this.http.get("/api/integrations/google/analytics/status");
    }
    GoogleAnalyticsGetProperties() {
        return this.http.post("/api/integrations/google/analytics/properties");
    }
    GoogleAnalyticsSetProperty(dto) {
        return this.http.post("/api/integrations/google/analytics/property", dto);
    }
    GoogleAnalyticsGetProperty() {
        return this.http.get("/api/integrations/google/analytics/property");
    }
    GoogleAnalyticsGetTraffic() {
        return this.http.get("/api/integrations/google/analytics/traffic");
    }
    MetaAdsConnect() {
        return this.http.get("/api/integrations/meta-ads/connect");
    }
    MetaAdsDisconnect() {
        return this.http.post("/api/integrations/meta-ads/disconnect");
    }
    GetMetaAdsStatus() {
        return this.http.get("/api/integrations/meta-ads/status");
    }
    GetMetaAdsAdAccounts() {
        return this.http.get("/api/integrations/meta-ads/ad-accounts");
    }
    SetMetaAdsAdAccount(dto) {
        return this.http.post("/api/integrations/meta-ads/ad-account", dto);
    }
    GetMetaAdsAdAccount() {
        return this.http.get("/api/integrations/meta-ads/ad-account");
    }
    GetMetaAdsOverview() {
        return this.http.get("/api/integrations/meta-ads/overview");
    }
    GetMetaAdsAdminConnections() {
        return this.http.get("/api/integrations/meta-ads/admin/connections");
    }
    GetMetaAdsAdminCheck() {
        return this.http.get("/api/integrations/meta-ads/admin/check");
    }
    SearchMetaAdsInterests(query) {
        return this.http.get(`/api/integrations/meta-ads/interests/search?q=${encodeURIComponent(query)}`);
    }
    GetMetaAdsPixels() {
        return this.http.get("/api/integrations/meta-ads/pixels");
    }
    GetMetaAdsRoles() {
        return this.http.get("/api/integrations/meta-ads/roles");
    }
    SetMetaAdsRole(dto) {
        return this.http.post("/api/integrations/meta-ads/roles", dto);
    }
    DeleteMetaAdsRole(userId) {
        return this.http.delete(`/api/integrations/meta-ads/roles/${userId}`);
    }
    GetMetaAdsDrafts() {
        return this.http.get("/api/integrations/meta-ads/campaigns/drafts");
    }
    GetMetaAdsDraft(draftId) {
        return this.http.get(`/api/integrations/meta-ads/campaigns/drafts/${draftId}`);
    }
    SaveMetaAdsDraft(dto) {
        return this.http.post("/api/integrations/meta-ads/campaigns/drafts", dto);
    }
    DeleteMetaAdsDraft(draftId) {
        return this.http.delete(`/api/integrations/meta-ads/campaigns/drafts/${draftId}`);
    }
    PublishMetaAdsCampaign(draftId) {
        return this.http.post(`/api/integrations/meta-ads/campaigns/publish/${draftId}`);
    }
    GetMetaAdsCampaignForEdit(campaignId) {
        return this.http.get(`/api/integrations/meta-ads/campaigns/${campaignId}/for-edit`);
    }
    GetMetaAdsLeadForms() {
        return this.http.get("/api/integrations/meta-ads/lead-forms");
    }
    GetMetaAdsMetaLeadForms() {
        return this.http.get("/api/integrations/meta-ads/lead-forms/meta");
    }
    GetMetaAdsLeadForm(formId) {
        return this.http.get(`/api/integrations/meta-ads/lead-forms/${formId}`);
    }
    SaveMetaAdsLeadForm(dto) {
        return this.http.post("/api/integrations/meta-ads/lead-forms", dto);
    }
    DeleteMetaAdsLeadForm(formId) {
        return this.http.delete(`/api/integrations/meta-ads/lead-forms/${formId}`);
    }
    GetMetaAdsLeads(formId) {
        const params = formId ? `?formId=${formId}` : "";
        return this.http.get(`/api/integrations/meta-ads/leads${params}`);
    }
    SyncMetaAdsLeads() {
        return this.http.post("/api/integrations/meta-ads/leads/sync");
    }
    GetMetaAdsPages() {
        return this.http.get("/api/integrations/meta-ads/pages");
    }
    GetMetaAdsPage() {
        return this.http.get("/api/integrations/meta-ads/page");
    }
    SetMetaAdsPage(pageId) {
        return this.http.post("/api/integrations/meta-ads/page", {
            id: pageId,
        });
    }
    GetMetaAdsMyRole() {
        return this.http.get("/api/integrations/meta-ads/my-role");
    }
    GooglePlacesAutocomplete(query) {
        return this.http.get(`/api/integrations/google/places/autocomplete?q=${query}`);
    }
    YouTubeConnect(addChannel = false) {
        const query = addChannel ? "?add=true" : "";
        return this.http.get(`/api/integrations/google/youtube/connect${query}`);
    }
    YouTubeStatus() {
        return this.http.get("/api/integrations/google/youtube/status");
    }
    YouTubeDisconnect(channelId) {
        return this.http.post("/api/integrations/google/youtube/disconnect", channelId ? { id: channelId } : undefined);
    }
    YouTubeGetChannels() {
        return this.http.get("/api/integrations/google/youtube/channels");
    }
    YouTubeSetChannel(dto) {
        return this.http.post("/api/integrations/google/youtube/channel", dto);
    }
    GetYouTubeOverview() {
        return this.http.get("/api/integrations/google/youtube/overview");
    }
    GooglePlacesDetails(placeId) {
        return this.http.get(`/api/integrations/google/places/details?placeId=${encodeURIComponent(placeId)}`);
    }
    GetMetaAdsDeliveryEstimate(dto) {
        return this.http.post("/api/integrations/meta-ads/delivery-estimate", dto);
    }
    GetMetaAdsDashboard(from, to) {
        return this.http.get(`/api/integrations/meta-ads/reporting/dashboard?from=${from}&to=${to}`);
    }
    GetMetaAdsCampaigns(from, to) {
        return this.http.get(`/api/integrations/meta-ads/reporting/campaigns?from=${from}&to=${to}`);
    }
    GetMetaAdsCampaignAdSets(campaignId, from, to) {
        return this.http.get(`/api/integrations/meta-ads/reporting/campaigns/${campaignId}/adsets?from=${from}&to=${to}`);
    }
    GetMetaAdsAdSetAds(adSetId, from, to) {
        return this.http.get(`/api/integrations/meta-ads/reporting/adsets/${adSetId}/ads?from=${from}&to=${to}`);
    }
    GetMetaAdsCrossClientOverview(from, to) {
        return this.http.get(`/api/integrations/meta-ads/reporting/overview?from=${from}&to=${to}`);
    }
    GetMetaAdsDisapprovedAds() {
        return this.http.get("/api/integrations/meta-ads/reporting/disapproved");
    }
    SyncMetaAdsInsights() {
        return this.http.post("/api/integrations/meta-ads/reporting/sync");
    }
    UpdateMetaAdsCampaignStatus(campaignId, dto) {
        return this.http.post(`/api/integrations/meta-ads/campaigns/${campaignId}/status`, dto);
    }
    UpdateMetaAdsAdSetStatus(adSetId, dto) {
        return this.http.post(`/api/integrations/meta-ads/adsets/${adSetId}/status`, dto);
    }
    UpdateMetaAdsAdStatus(adId, dto) {
        return this.http.post(`/api/integrations/meta-ads/ads/${adId}/status`, dto);
    }
    // ── Audience methods ──
    GetMetaAdsAudiences() {
        return this.http.get("/api/integrations/meta-ads/audiences");
    }
    GetMetaAdsAudience(id) {
        return this.http.get(`/api/integrations/meta-ads/audiences/${id}`);
    }
    CreateMetaAdsCustomListAudience(dto) {
        return this.http.post("/api/integrations/meta-ads/audiences/custom-list", dto);
    }
    CreateMetaAdsWebsiteAudience(dto) {
        return this.http.post("/api/integrations/meta-ads/audiences/website", dto);
    }
    CreateMetaAdsEngagementAudience(dto) {
        return this.http.post("/api/integrations/meta-ads/audiences/engagement", dto);
    }
    CreateMetaAdsLookalikeAudience(dto) {
        return this.http.post("/api/integrations/meta-ads/audiences/lookalike", dto);
    }
    RenameMetaAdsAudience(id, dto) {
        return this.http.post(`/api/integrations/meta-ads/audiences/${id}/rename`, dto);
    }
    DeleteMetaAdsAudience(id) {
        return this.http.delete(`/api/integrations/meta-ads/audiences/${id}`);
    }
    RefreshMetaAdsAudienceStatus(id) {
        return this.http.post(`/api/integrations/meta-ads/audiences/${id}/refresh`);
    }
    // ── Campaign Templates ──
    GetMetaAdsCampaignTemplates(objective) {
        const params = objective ? `?objective=${objective}` : "";
        return this.http.get(`/api/integrations/meta-ads/campaigns/templates${params}`);
    }
    GetMetaAdsCampaignTemplate(id) {
        return this.http.get(`/api/integrations/meta-ads/campaigns/templates/${id}`);
    }
    CreateMetaAdsCampaignTemplate(dto) {
        return this.http.post("/api/integrations/meta-ads/campaigns/templates", dto);
    }
    UpdateMetaAdsCampaignTemplate(id, dto) {
        return this.http.put(`/api/integrations/meta-ads/campaigns/templates/${id}`, dto);
    }
    DeleteMetaAdsCampaignTemplate(id) {
        return this.http.delete(`/api/integrations/meta-ads/campaigns/templates/${id}`);
    }
    SaveMetaAdsDraftAsTemplate(draftId, dto) {
        return this.http.post(`/api/integrations/meta-ads/campaigns/drafts/${draftId}/save-as-template`, dto);
    }
    // ── Report Templates ──
    GetMetaAdsReportTemplates() {
        return this.http.get("/api/integrations/meta-ads/reports/templates");
    }
    GetMetaAdsReportTemplate(id) {
        return this.http.get(`/api/integrations/meta-ads/reports/templates/${id}`);
    }
    CreateMetaAdsReportTemplate(dto) {
        return this.http.post("/api/integrations/meta-ads/reports/templates", dto);
    }
    UpdateMetaAdsReportTemplate(id, dto) {
        return this.http.put(`/api/integrations/meta-ads/reports/templates/${id}`, dto);
    }
    DeleteMetaAdsReportTemplate(id) {
        return this.http.delete(`/api/integrations/meta-ads/reports/templates/${id}`);
    }
    // ── Report Schedules ──
    GetMetaAdsReportSchedules() {
        return this.http.get("/api/integrations/meta-ads/reports/schedules");
    }
    CreateMetaAdsReportSchedule(dto) {
        return this.http.post("/api/integrations/meta-ads/reports/schedules", dto);
    }
    UpdateMetaAdsReportSchedule(id, dto) {
        return this.http.put(`/api/integrations/meta-ads/reports/schedules/${id}`, dto);
    }
    DeleteMetaAdsReportSchedule(id) {
        return this.http.delete(`/api/integrations/meta-ads/reports/schedules/${id}`);
    }
    // ── Report Branding ──
    GetMetaAdsReportBranding() {
        return this.http.get("/api/integrations/meta-ads/reports/branding");
    }
    UpdateMetaAdsReportBranding(dto) {
        return this.http.put("/api/integrations/meta-ads/reports/branding", dto);
    }
    // ── Report Generation ──
    GenerateMetaAdsReport(dto) {
        return this.http.post("/api/integrations/meta-ads/reports/generate", dto, { responseType: "blob" });
    }
    SendMetaAdsTestReport(dto) {
        return this.http.post("/api/integrations/meta-ads/reports/send-test", dto);
    }
    // ── Dashboard Comparison ──
    GetMetaAdsDashboardComparison(from, to, compareFrom, compareTo) {
        return this.http.get("/api/integrations/meta-ads/reporting/dashboard/comparison", { params: { from, to, compareFrom, compareTo } });
    }
    // ── Campaign Approvals ──
    GetMetaAdsApprovalSettings() {
        return this.http.get("/api/integrations/meta-ads/approvals/settings");
    }
    UpdateMetaAdsApprovalEnabled(enabled) {
        return this.http.put("/api/integrations/meta-ads/approvals/settings/enabled", { enabled });
    }
    SetMetaAdsApprovers(dto) {
        return this.http.put("/api/integrations/meta-ads/approvals/settings/approvers", dto);
    }
    SubmitMetaAdsCampaignForApproval(dto) {
        return this.http.post("/api/integrations/meta-ads/approvals/submit", dto);
    }
    GetMetaAdsApprovals(status) {
        const params = status ? `?status=${status}` : "";
        return this.http.get(`/api/integrations/meta-ads/approvals${params}`);
    }
    GetMetaAdsApproval(id) {
        return this.http.get(`/api/integrations/meta-ads/approvals/${id}`);
    }
    ApproveMetaAdsCampaign(id, dto) {
        return this.http.post(`/api/integrations/meta-ads/approvals/${id}/approve`, dto);
    }
    RejectMetaAdsCampaign(id, dto) {
        return this.http.post(`/api/integrations/meta-ads/approvals/${id}/reject`, dto);
    }
    GetMetaAdsPendingApprovalCount() {
        return this.http.get("/api/integrations/meta-ads/approvals/pending-count");
    }
    // ── Geo Targeting ──
    SearchMetaAdsGeoLocations(query, type) {
        return this.http.get(`/api/integrations/meta-ads/geo/search?q=${encodeURIComponent(query)}&type=${encodeURIComponent(type)}`);
    }
    ValidateMetaAdsZipCodes(zipCodes, countryCode) {
        return this.http.post("/api/integrations/meta-ads/geo/validate-zips", { zipCodes, countryCode });
    }
    SuggestMetaAdsGeoLocations(lat, lng) {
        return this.http.get(`/api/integrations/meta-ads/geo/suggest?lat=${lat}&lng=${lng}`);
    }
    GetMetaAdsGeoTemplates() {
        return this.http.get("/api/integrations/meta-ads/geo/templates");
    }
    GetMetaAdsGeoTemplate(id) {
        return this.http.get(`/api/integrations/meta-ads/geo/templates/${id}`);
    }
    CreateMetaAdsGeoTemplate(dto) {
        return this.http.post("/api/integrations/meta-ads/geo/templates", dto);
    }
    UpdateMetaAdsGeoTemplate(id, dto) {
        return this.http.put(`/api/integrations/meta-ads/geo/templates/${id}`, dto);
    }
    DeleteMetaAdsGeoTemplate(id) {
        return this.http.delete(`/api/integrations/meta-ads/geo/templates/${id}`);
    }
    GetBillingStatus() {
        return this.http.get("/api/billing/subscription");
    }
    GetInvoices() {
        return this.http.get("/api/billing/invoices");
    }
    GetPlans() {
        return this.http.get("/api/billing/plans");
    }
    UpgradeSubscription(dto) {
        return this.http.post("/api/billing/upgrade", dto);
    }
    GetBillingEntitlements() {
        return this.http.get("/api/billing/entitlements");
    }
    AddBillingAddon(dto) {
        return this.http.post("/api/billing/addons", dto);
    }
    RemoveBillingAddon(dto) {
        return this.http.post("/api/billing/addons/remove", dto);
    }
    CancelSubscription() {
        return this.http.post("/api/billing/cancel");
    }
    GetStripeCustomerPortal() {
        return this.http.post("/api/billing/portal");
    }
    GetMediaList(query) {
        return this.http.get("/api/content/files", {
            params: { query },
        });
    }
    GetMediaBatch(dto) {
        return this.http.post("/api/content/files/batch", {
            IDs: dto,
        });
    }
    GetMediaPage(params) {
        const searchParams = new URLSearchParams();
        if (params.folderId !== undefined) {
            searchParams.append("folderId", params.folderId === null ? "null" : String(params.folderId));
        }
        if (params.cursor !== undefined)
            searchParams.append("cursor", String(params.cursor));
        if (params.limit !== undefined)
            searchParams.append("limit", String(params.limit));
        if (params.query)
            searchParams.append("query", params.query);
        if (params.source)
            searchParams.append("source", params.source);
        const qs = searchParams.toString();
        return this.http.get(`/api/content/files/page${qs ? `?${qs}` : ""}`);
    }
    GetMediaFolders() {
        return this.http.get("/api/content/folders");
    }
    CreateMediaFolder(dto) {
        return this.http.post("/api/content/folders", dto);
    }
    RenameMediaFolder(id, dto) {
        return this.http.patch(`/api/content/folders/${id}`, dto);
    }
    DeleteMediaFolder(id) {
        return this.http.delete(`/api/content/folders/${id}`);
    }
    MoveFiles(dto) {
        return this.http.post("/api/content/files/move", dto);
    }
    UpdateFile(id, dto) {
        return this.http.patch(`/api/content/${id}`, dto);
    }
    DeleteFile(id) {
        return this.http.delete(`/api/content/${id}`);
    }
    CompanyOverviewWebsite(dto) {
        return this.lrp({
            method: "POST",
            url: "/api/company/overview",
            data: dto,
        });
    }
    CompanyIdealCustomer() {
        return this.lrp({
            method: "POST",
            url: "/api/company/ideal-customer",
        });
    }
    CompanyUpdateICP(dto) {
        return this.http.post("/api/company/update/icp", dto);
    }
    UploadCompanyLogo(file) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http.post("/api/company/logo/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }
    ExtractColorsFromLogo() {
        return this.http.post("/api/company/logo/extract-colors");
    }
    UpdateUserRole(companyID, userID, role) {
        return this.http.patch(`/api/company/${companyID}/users/${userID}/role`, {
            role,
        });
    }
    UpdateApprovalSetting(requirePostApproval) {
        return this.http.patch("/api/company/settings/approval", {
            requirePostApproval,
        });
    }
    GetLinkedinProfiles() {
        return this.http.get("/api/integrations/linkedin/profiles");
    }
    SetLinkedinProfile(dto) {
        return this.http.post("/api/integrations/linkedin/profile", dto);
    }
    GetGuidelines() {
        return this.http.get("/api/company/guidelines");
    }
    CreateGuideline(dto) {
        return this.http.post("/api/company/guidelines", dto);
    }
    DeleteGuideline(id) {
        return this.http.delete(`/api/company/guidelines/${id}`);
    }
    UploadGuidelineDocument(type, file) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", type);
        return this.http.post("/api/company/guidelines/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }
    GetAppMetadata() {
        return this.http.get("/api/metadata");
    }
    // Inbox Methods
    GetInboxConversations(filters) {
        const params = new URLSearchParams();
        if (filters === null || filters === void 0 ? void 0 : filters.platform)
            params.append("platform", filters.platform);
        if (filters === null || filters === void 0 ? void 0 : filters.conversationType)
            params.append("type", filters.conversationType);
        if ((filters === null || filters === void 0 ? void 0 : filters.archived) !== undefined)
            params.append("archived", String(filters.archived));
        if (filters === null || filters === void 0 ? void 0 : filters.unreadOnly)
            params.append("unreadOnly", "true");
        const queryString = params.toString();
        return this.http.get(`/api/inbox/conversations${queryString ? `?${queryString}` : ""}`);
    }
    GetInboxConversation(id) {
        return this.http.get(`/api/inbox/conversations/${id}`);
    }
    MarkInboxConversationRead(id) {
        return this.http.post(`/api/inbox/conversations/${id}/read`);
    }
    ArchiveInboxConversation(id) {
        return this.http.post(`/api/inbox/conversations/${id}/archive`);
    }
    UnarchiveInboxConversation(id) {
        return this.http.post(`/api/inbox/conversations/${id}/unarchive`);
    }
    SendInboxMessage(dto) {
        return this.http.post("/api/inbox/messages", dto);
    }
    // ── TikTok Ads ──
    TikTokAdsConnect() {
        return this.http.get("/api/integrations/tiktok-ads/connect");
    }
    GetTikTokAdsStatus() {
        return this.http.get("/api/integrations/tiktok-ads/status");
    }
    GetTikTokAdsAdvertisers() {
        return this.http.get("/api/integrations/tiktok-ads/advertisers");
    }
    SetTikTokAdsAdvertiser(dto) {
        return this.http.post("/api/integrations/tiktok-ads/advertiser", dto);
    }
    TikTokAdsDisconnect() {
        return this.http.post("/api/integrations/tiktok-ads/disconnect");
    }
    GetTikTokAdsReport(days) {
        return this.http.get(`/api/integrations/tiktok-ads/report?days=${days}`);
    }
    SyncTikTokAdsInsights(days) {
        return this.http.post(`/api/integrations/tiktok-ads/sync?days=${days}`);
    }
    GetTikTokAdsDrafts() {
        return this.http.get("/api/integrations/tiktok-ads/campaigns/drafts");
    }
    GetTikTokAdsDraft(draftId) {
        return this.http.get(`/api/integrations/tiktok-ads/campaigns/drafts/${draftId}`);
    }
    SaveTikTokAdsDraft(dto) {
        return this.http.post("/api/integrations/tiktok-ads/campaigns/drafts", dto);
    }
    DeleteTikTokAdsDraft(draftId) {
        return this.http.delete(`/api/integrations/tiktok-ads/campaigns/drafts/${draftId}`);
    }
    PublishTikTokAdsCampaign(draftId) {
        return this.http.post(`/api/integrations/tiktok-ads/campaigns/publish/${draftId}`);
    }
    GetTikTokAdsIdentities() {
        return this.http.get("/api/integrations/tiktok-ads/identities");
    }
    GetTikTokAdsRegions() {
        return this.http.get("/api/integrations/tiktok-ads/regions");
    }
    GetTikTokAdsInstantForms() {
        return this.http.get("/api/integrations/tiktok-ads/instant-forms");
    }
    GetTikTokAdsPixels() {
        return this.http.get("/api/integrations/tiktok-ads/pixels");
    }
    GetTikTokAdsMockLeads(pageId) {
        return this.http.get("/api/integrations/tiktok-ads/leads/mock", { params: { pageId } });
    }
    CreateTikTokAdsMockLead(pageId) {
        return this.http.post("/api/integrations/tiktok-ads/leads/mock", { pageId });
    }
    DeleteTikTokAdsMockLead(pageId) {
        return this.http.delete("/api/integrations/tiktok-ads/leads/mock", {
            params: { pageId },
        });
    }
    UpdateTikTokAdsCampaignStatus(campaignId, dto) {
        return this.http.post(`/api/integrations/tiktok-ads/campaigns/${campaignId}/status`, dto);
    }
    UpdateTikTokAdsCampaignBudget(campaignId, dto) {
        return this.http.post(`/api/integrations/tiktok-ads/campaigns/${campaignId}/budget`, dto);
    }
    UpdateTikTokAdsAdGroupStatus(adGroupId, dto) {
        return this.http.post(`/api/integrations/tiktok-ads/adgroups/${adGroupId}/status`, dto);
    }
    UpdateTikTokAdsAdGroupBudget(adGroupId, dto) {
        return this.http.post(`/api/integrations/tiktok-ads/adgroups/${adGroupId}/budget`, dto);
    }
    GetTikTokAdsReallocation(days) {
        return this.http.get(`/api/integrations/tiktok-ads/reallocation?days=${days}`);
    }
    ApplyTikTokAdsReallocation(dto) {
        return this.http.post("/api/integrations/tiktok-ads/reallocation/apply", dto);
    }
    GetTikTokAdsRecommendations() {
        return this.http.get("/api/integrations/tiktok-ads/recommendations");
    }
    SuggestInboxReply(conversationId, messageId) {
        return this.http.post(`/api/inbox/conversations/${conversationId}/messages/${messageId}/suggest-reply`);
    }
    SetInboxCommentHidden(conversationId, messageId, dto) {
        return this.http.post(`/api/inbox/conversations/${conversationId}/messages/${messageId}/hidden`, dto);
    }
    TriggerInboxSync() {
        return this.http.post("/api/inbox/sync");
    }
    GetInboxSyncStatus() {
        return this.http.get("/api/inbox/sync/status");
    }
    GetInboxUnreadCount() {
        return this.http.get("/api/inbox/unread-count");
    }
    GetNotifications() {
        return this.http.get("/api/notifications");
    }
    GetNotificationUnreadCount() {
        return this.http.get("/api/notifications/unread-count");
    }
    GetNotificationPreferences() {
        return this.http.get("/api/notifications/preferences");
    }
    UpdateNotificationPreferences(prefs) {
        return this.http.put("/api/notifications/preferences", prefs);
    }
    MarkNotificationRead(id) {
        return this.http.post(`/api/notifications/${id}/read`);
    }
    MarkAllNotificationsRead() {
        return this.http.post("/api/notifications/read-all");
    }
    // SEO AI Audit Methods
    GetSeoAudit() {
        return this.http.get("/api/seo-audit");
    }
    RunSeoAudit(dto) {
        return this.http.post("/api/seo-audit", dto);
    }
    GenerateJsonLd(dto) {
        return this.http.post("/api/seo-audit/json-ld", dto);
    }
    PushJsonLdToWordpress(dto) {
        return this.http.post("/api/seo-audit/json-ld/push-to-wordpress", dto);
    }
    // SEO Reporting Methods
    GetSeoConfig() {
        return this.http.get("/api/seo/config");
    }
    UpdateSeoConfig(dto) {
        return this.http.put("/api/seo/config", dto);
    }
    SeedSeoConfig() {
        return this.lrp({
            method: "POST",
            url: "/api/seo/config/seed",
        });
    }
    SearchSeoLocations(query) {
        return this.http.get(`/api/seo/config/locations?q=${encodeURIComponent(query)}`);
    }
    RunKeywordResearch() {
        return this.lrp({
            method: "POST",
            url: "/api/seo/keyword-research",
        });
    }
    GetLatestKeywordResearch() {
        return this.http.get("/api/seo/keyword-research/latest");
    }
    RunAIVisibility() {
        return this.lrp({
            method: "POST",
            url: "/api/seo/ai-visibility",
        });
    }
    GetLatestAIVisibility() {
        return this.http.get("/api/seo/ai-visibility/latest");
    }
    GetSeoMetrics(months = 6) {
        return this.http.get(`/api/seo/metrics?months=${months}`);
    }
    lrp(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: lrp } = yield this.http.request(config);
            while (lrp.status === "running") {
                yield new Promise((resolve) => setTimeout(resolve, 3000));
                const res = yield this.http.get(`/api/lrp/${lrp.UUID}`);
                if (res.status === 404) {
                    throw new Error("There was an issue processing your request. Please try again.");
                }
                if (res.status !== 202) {
                    return res;
                }
            }
            throw new Error("There was an issue processing your request. Please try again.");
        });
    }
}
exports.HttpInterface = HttpInterface;
